export function normalizeReviewLanguage(language) {
  return String(language || "en").toLowerCase().split("-")[0];
}

export function getLocalizedReviewComment(review, language) {
  if (!review) return "";

  const normalizedLanguage = normalizeReviewLanguage(language);
  const translatedComment = review.translations?.[normalizedLanguage];

  return translatedComment || review.comment || "";
}
